function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconHeart = function SvgIconHeart(props) {
  return h("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), h("g", {
    fill: "none",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1.5
  }, h("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), h("circle", {
    cx: 20,
    cy: 20,
    r: 19.25
  })), h("path", {
    fill: "#fff",
    d: "M24.192 13.01a4.86 4.86 0 0 1 3.524 1.216 4.55 4.55 0 0 1 1.277 3.411 5.14 5.14 0 0 1-1.067 3.02 9.6 9.6 0 0 1-1.21 1.452l-6.2 5.957a.77.77 0 0 1-1.037 0l-6.193-5.957a7 7 0 0 1-1.156-1.334 5.6 5.6 0 0 1-1.126-3.112 4.61 4.61 0 0 1 1.274-3.438 4.77 4.77 0 0 1 3.527-1.215 4.7 4.7 0 0 1 2.43.771 11 11 0 0 1 1.749 1.334 8.3 8.3 0 0 1 1.749-1.334 4.8 4.8 0 0 1 2.459-.771",
    "data-name": "Path 87"
  }));
};
export default SvgIconHeart;